import {isFunction} from "lodash";
import {firestore} from "../../config/firebaseConfig";
import {itemsCollection, referencesCollection} from "../../constant";
import {ThunksError} from "../../utils/thunks";
import {createKeyword, updateKeyword} from "./keyword.thunks";
import {createSlice} from "@reduxjs/toolkit";


const slice = createSlice({
    name: 'product',
    initialState: {
        query: null,
        cursor: null
    },
    reducers: {
        setSnap: (state, action) => {
            state.query = action.payload?.query
            state.cursor = action.payload?.cursor
        }
    }
})

export const {setSnap} = slice.actions

const productReducer = slice.reducer;

export default productReducer;

export const selectProduct = state => state.product
export const selectItems = state => state.item


export const createItem = (data, callback) => {
    return async (dispatch) => {
        try {

            const doc = await itemsCollection.add(data);

            const keywordData = {
                id: doc?.id || null,
                name: data?.Name,
                barCode: data?.UPC,
                internalId: data?.InternalId,
                imageUrl: data?.ImageUrl,
                QuantityInPO: data?.QuantityInPO,
                QuantityInShpping: data?.QuantityInShpping,
                QuantityAvailable: data?.QuantityAvailable,
            }

            dispatch(createKeyword(keywordData))

            isFunction(callback) && callback()

        } catch (error) {
            ThunksError(error)
        }
    }
}

export const updateItem = (itemId, data, callback) => {
    return async (dispatch) => {
        try {

            await firestore.runTransaction(transaction => {

                const docRef = itemsCollection.doc(itemId);

                return transaction.get(docRef).then(doc => {
                    if (doc.exists) {
                        transaction.set(docRef, {
                            ...doc.data(),
                            ...data
                        }, {merge: true})
                    }
                })

            })

            const keywordData = {
                id: itemId,
                name: data?.Name,
                barCode: data?.UPC,
                internalId: data?.InternalId,
                imageUrl: data?.ImageUrl,
                QuantityInPO: data?.QuantityInPO,
                QuantityInShpping: data?.QuantityInShpping,
                QuantityAvailable: data?.QuantityAvailable,
                
            }
            console.log(keywordData)


            dispatch(updateKeyword(keywordData))

            isFunction(callback) && callback()

        } catch (error) {
            ThunksError(error)
        }
    }
}

export const getItemStat = (internalId, callback) => {
    return async () => {
        try {

            const snap = await referencesCollection.doc('statistiqueOrder').get();

            const statCollectionNames = snap.data()?.order || [];

            let list = [];

            for (const name of statCollectionNames) {
                const doc = await firestore.collection(name).doc(internalId).get()
                doc.exists && list.push(doc.data())
            }


            isFunction(callback) && callback()

        } catch (error) {
            ThunksError(error)
        }
    }
}
